<template>
 <!-- 查看证书弹窗 -->
     <el-dialog
     :append-to-body="true"
     class="secretView"
      :close-on-click-modal="false"
      :visible.sync="secretParams.secretVisible"
      width="32%">
      <span slot="title" class="title">
        <span>设备证书</span>
      </span>
      <el-row>
        设备证书<span class="btn" @click="oneClickCopy">一键复制</span>
      </el-row>
      <el-row :span="24" class="secretContent">
        <el-col :span="8">productKey</el-col><el-col :span="16">{{deviceDetail.productKey}}<span class="btn" @click="copy(deviceDetail.productKey)">复制</span></el-col>
        <el-col :span="8">deviceName</el-col><el-col :span="16">{{deviceDetail.deviceName}}<span class="btn" @click="copy(deviceDetail.deviceName)">复制</span></el-col>
        <el-col :span="8">deviceSecret</el-col><el-col :span="16">{{deviceDetail.deviceSecret}}<span class="btn" @click="copy(deviceDetail.deviceSecret)">复制</span></el-col>
      </el-row>
      <el-row>烧录方式介绍</el-row>
      <el-row
      v-show="!secretParams.introduceVisible"
      class="toggleBtn">
        <div  @click="secretParams.introduceVisible = true">
          <span class="el-icon-arrow-down"></span>一机一密、一型一密介绍
        </div>
      </el-row>
     <div v-show="secretParams.introduceVisible">
        <el-row>一型一密</el-row>
      <el-row>同一产品下所有设备可以烧录相同产品证书（即 ProductKey 和 ProductSecret ）。设备发送激活请求时，物联网平台进行产品身份确认，认证通过，下发该设备对应的 DeviceSecret。</el-row>
       <el-row>一机一密</el-row>
       <el-row class="tips">
        <div><span class="el-icon-info"></span></div>
        <div>
          <span class="">如果您期望使用一型一密烧录方式，请前往对应的产品详情，来获取产品证书烧录，</span>
          <span class="link" @click="goProduct">前往查看</span>
        </div>
      </el-row>
       <el-row>每个设备烧录其唯一的设备证书（ProductKey、DeviceName 和 DeviceSecret）。</el-row>
       <el-row>当设备与物联网平台建立连接时，物联网平台对其携带的设备证书信息进行认证。</el-row>
     </div>
      <el-row
      v-show="secretParams.introduceVisible"
      class="toggleBtn">
        <div  @click="secretParams.introduceVisible = false"><span class="el-icon-arrow-up"></span>收起</div>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="secretParams.secretVisible=false">关 闭</el-button>
      </span>
     </el-dialog>
</template>
<script>
import { copy } from '@/utils'
export default {
  props: {
    secretParams: {
      type: Object
    },
    deviceDetail: {
      deviceDetail: {
        type: Object
      }
    }
  },
  methods: {
    oneClickCopy () {
      const params = {
        productKey: this.deviceDetail.productKey,
        deviceName: this.deviceDetail.deviceName,
        deviceSecret: this.deviceDetail.deviceSecret
      }
      copy(JSON.stringify(params), () => {
        this.$message({
          type: 'success',
          message: '复制成功'
        })
      })
    },
    copy (val) {
      copy(val, () => {
        this.$message({
          type: 'success',
          message: '复制成功'
        })
      })
    },
    goProduct () {
      const infos = JSON.stringify({
        productKey: this.deviceDetail.productKey,
        productName: this.deviceDetail.productName
      })
      this.$router.push({
        path: '/productControl/productDetail',
        query: { sRow: infos }
      })
    }
  }
}
</script>
<style lang="less" scope>
   .secretView{
    font-size: 12px;
    .title{
      font-size: 16px;
    }
    .btn{
       color: rgb(0, 112, 204);
      margin-left: 10px;
      cursor: pointer;
      font-size: 10px;
    }
    .el-row{
       margin-top: 10px;
    }
    .secretContent{
       border-left: 1px solid #ecedee;
        border-top: 1px solid #ecedee;
      .el-col{
         padding-left: 10px;
        line-height: 50px;
        border-right: 1px solid #ecedee;
        border-bottom: 1px solid #ecedee;
        &:nth-child(odd){
          background-color: #fbfbfc;
        }
      }
    }
    .toggleBtn{
        color: #0070cc;
        cursor: pointer;
    }
    .tips{
      padding: 15px;
      display: flex;
      background-color: #e5f3ff;
      font-size: 10px;
    }
    .el-icon-info{
      color: #0070cc;
      margin-right: 10px;
      font-size: 16px;
    }
    .link{
      color: #0070cc;
      cursor: pointer;
    }
  }
</style>
